<template>
  <div :class="containerClasses">
    <span v-if="formatPublishedAt">{{ formatPublishedAt }}</span>
    <span v-if="formatPublishedAt && displayAuthor" class="mx-1">•</span>
    <span v-if="formatPublishedAt">{{ displayAuthor }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { ArticleMetaProps } from '~~/shared/types/common';

const props = withDefaults(defineProps<ArticleMetaProps>(), {
  isFeatured: false,
  locale: 'en-US'
})

const publishAtComputed = computed(() => (props.publishAt ? props.publishAt : undefined))
const authorNameComputed = computed(() => (props.authorName && props.authorName.trim() ? props.authorName : undefined))
const isFeaturedComputed = computed(() => !!props.isFeatured)
const titlePosition = computed(() =>
  props.titlePos ? props.titlePos : undefined
)

const formatPublishedAt = computed(() => {
  if (!publishAtComputed.value) return ''
  const date = new Date(publishAtComputed.value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(props.locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date)
})

const displayAuthor = computed(() => authorNameComputed.value ?? '')

const containerClasses = computed(() => {
  if (isFeaturedComputed.value) {
    return 'text-white text-base font-normal leading-[1.125rem] mb-[1rem]'
  }

  return [
    'text-gray-700 text-[0.857rem] font-normal leading-[1.286rem] blog-publish-sub',
    titlePosition.value === 'bottom' ? 'pb-[1rem]' : ''
  ].join(' ')
})

</script>
